<template>
  <div v-if="show" ref="orderItem" class="order-content">
    <div class="order-item">
      <div class="t-l course-item-title single-line">{{ obj.productName }}</div>
      <div class="flex course-item-bottom">
        <van-image
          :width="pxTovw(200)"
          :height="pxTovw(112)"
          :src="obj.productPic"
          class="course-item-bottom-img"
        />
        <div class="course-item-right">
          <div class="flex course-item-right-title flex-m">
            <div class="course-item-right-text single-line">{{ obj.productAttr }}</div>
          </div>
          <div :style="'margin-top:' + pxTovw(12)+'px;'" class="flex flex-m">
            <span v-if="obj.salePrice || obj.salePrice === 0" :class="showFontColorBlack ? 'course-price-black':'course-price'">￥{{ obj.salePrice || obj.salePrice === 0 ? obj.salePrice.toFixed(2) : '' }}</span>
            <span v-if="obj.courseCount" class="course-count">共{{ obj.courseCount }}课次</span>
            <span v-if="~~obj.productType === 4" class="course-count"> x {{ obj.quantity || obj.productCount }}</span>
          </div>
        </div>
      </div>
      <p v-if="obj.productGive==='1'" class="activities" style="margin-top: 10px;" @click="toFreeClass2(obj)">
        <span>
          <van-tag type="warning" color="#FF4B13">赠课</van-tag>
          <span class="ac-title">{{ '该课程可领取赠课' }}</span>
        </span>
        <span class="to-active-page">
          {{ obj.frontOrderGiveItemResps&&obj.frontOrderGiveItemResps.length>0?'重新选择':'请选择' }}
          <van-icon name="arrow" />
        </span>
      </p>
      <div v-if="obj.frontOrderGiveItemResps&&obj.frontOrderGiveItemResps.length>0">
        <div v-for="item in obj.frontOrderGiveItemResps" :key="item.id" class="free-class-check">
          <div class="t-left">
            <div class="img">
              <img :src="item.pic" alt="">
            </div>

            <div class="t-right">
              <div class="class-names"><van-tag v-if="item.giveProductName" type="warning" color="#FF4B13">赠课</van-tag> {{ item.productName || item.giveProductName }}</div>
              <div class="class-price">
                <span>￥0.00</span>
                <span>￥{{ item.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showShipBtn && obj.recipientName" class="btn-show-ship" @click="handleShowShipDetail">物流信息</div>

      <slot :scope="obj" name="orderContent"/>

    </div>

    <van-overlay :show="showShippingDetail">
      <div class="shipping-content" @click.stop>
        <div class="shipping-title">
          <span class="shipping-title-name">{{ obj.productName }}</span>
          <div class="shipping-close flex flex-m flex-c" @click="showShippingDetail = false">
            <van-image
              :width="pxTovw(52)"
              :height="pxTovw(52)"
              :src="iconClose"
            />
          </div>
        </div>
        <div class="shipping-info">
          <div class="sub-title">收货信息</div>
          <div class="shipping-address">
            <div>{{ obj.recipientName + ' ' + obj.recipientPhoneNumber }}</div>
            <div>{{ obj.recipientFullAddress }}</div>
          </div>
          <div class="shipping-item">
            <span class="sub-title">物流公司</span>
            <span>{{ obj.orderItemShippingDetailResp ? obj.orderItemShippingDetailResp.shippingCompany : '-' }}</span>
          </div>
          <div class="shipping-item">
            <span class="sub-title">物流单号</span>
            <span class="ship-no-text">
              {{ obj.orderItemShippingDetailResp ? obj.orderItemShippingDetailResp.trackingNumber : '-' }}
              <van-button
                v-if="obj.orderItemShippingDetailResp && obj.orderItemShippingDetailResp.trackingNumber"
                class="copy-btn"
                plain
                type="info"
                round
                @click="copyShippingNo"
              >复制</van-button>
            </span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Image as VanImage, Icon, Tag, Overlay, Button, Toast } from 'vant';

export default {
  components: {
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    [Toast.name]: Toast,
    [Button.name]: Button
  },
  props: {
    obj: {
      type: Object,
      default: () => {
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    showFontColorBlack: {
      type: Boolean,
      default: false
    },
    showChangeCourse: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showShipBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      frontOrderGiveItemResps: [
        {
          'id': 150,
          'price': 66.66,
          'productPic': 'https://res-hlwx.oss-cn-hangzhou.aliyuncs.com/mingyouOMO/dev/d496f3c5294d4282a82c6b3c2775056c.jpg',
          'productName': '整除测试6666',
          'salePrice': 66.66,
          'productType': '1',
          'selected': false
        },
        {
          'id': 119,
          'price': 0.01,
          'productPic': 'https://res-hlwx.oss-cn-hangzhou.aliyuncs.com/mingyouOMO/dev/8ee93da8e9f540eaab3a466b84b99a09.jpeg',
          'productName': '奥特曼',
          'salePrice': 0.01,
          'productType': '4',
          'selected': true
        }
      ],
      iconClose: require('../../assets/img/course/icon-school-close.png'),
      showShippingDetail: false
    };
  },
  methods: {
    toFreeClass2(para) {
      this.$emit('toFreeClass1', para);
    },
    handleShowShipDetail() {
      this.showShippingDetail = true;
    },
    // 复制物流单号
    copyShippingNo() {
      if (!this.obj.orderItemShippingDetailResp || !this.obj.orderItemShippingDetailResp.trackingNumber) {
        return;
      }
      const text = this.obj.orderItemShippingDetailResp.trackingNumber;
      try {
        navigator.clipboard.writeText(text).then(() => {
          Toast('复制成功');
        });
      } catch (err) {
        console.log('复制失败', err);
        Toast('复制失败');
      }
    }
  }
};
</script>

<style scoped lang="scss">
.order-content {
  text-align: center;

  .free-title {
    height: 104px;
    display: flex;
    text-align: left;
    font-size: 26px;
    line-height: 104px;
    color: rgba(0, 0, 0, 0.65);
    align-items: center;
    font-weight: 600;

    /deep/ .van-icon {
      margin-right: 10px;
    }

  }

  .order-item {
    padding-top: 40px;
  }

  .course-item-title {
    width: 562px;
    height: 44px;
    font-size: 28px;
    font-family: $font-Medium;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.65);
    line-height: 44px;
    // padding-top: 40px;
  }

  .course-item-bottom {
    margin-top: 12px;

    /deep/ .van-image__img {
      border-radius: 10px;
    }

    /deep/ .van-image__error {
      border-radius: 10px;
    }
  }

  .activities {
    margin:0;
    padding:0;
    height: auto;
    font-size: 24px;
    line-height: 36px;
    background:none;
    color: rgba(0, 0, 0, 0.85);
    justify-content: space-between;

    @extend .flex-and-m;

    .ac-title {
      max-width: 80%;
      color: rgba(0, 0, 0, 0.45);

      @extend %one-line-text-overflow;
    }

    .to-active-page {
      @extend .flex-and-m;
      color: rgba(0, 0, 0, 0.45);
    }

  }

  .free-class-check {
    margin-bottom: 20px;
    background: #fff;
    padding-left: 60px;
    margin-top: 20px;

    .t-left {
      display: flex;
      justify-content: space-between;

      .course-item-bottom-img {
        border-radius: 10px;
      }

      .img {
        width: 140px;
        height: 78px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }

    .t-right {
      margin-left: 20px;
      width: 400px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .class-names {
        font-size: 26px;
        line-height: 40px;
        max-width: 400px;
        color: rgba(0, 0, 0, 0.65);
        font-weight: 600;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }

      .class-price {

        span:first-child {
          font-size: 26px;
          line-height: 40px;
          color: #FF4B13;
        }

        span:last-child {
          font-size: 20px;
          line-height: 40px;
          color: rgba(0, 0, 0, 0.25);
          text-decoration: line-through;
        }
      }
    }
  }

  .course-item-right {
    margin-left: 20px;
    width: 410px;

    &-title {
      height: 56px;
      background: #f8f8f8;
      border-radius: 10px;

      .icon-arrow-down {
        margin-right: 16px;
        margin-left: auto;
      }
    }

    &-text {
      max-width: 276px;
      height: 36px;
      font-size: 24px;
      font-family: $font-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 36px;
      margin-left: 20px;
    }

    .course-price {
      width: fit-content;
      height: 44px;
      font-size: 32px;
      font-family: $font-Medium;
      font-weight: 500;
      color: #ff4b13;
      line-height: 44px;
    }

    .course-price-black {
      width: fit-content;
      height: 44px;
      font-size: 32px;
      font-family: $font-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.65);
      line-height: 44px;
    }

    .course-count {
      width: fit-content;
      height: 36px;
      font-size: 26px;
      font-family: $font-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 36px;
      margin-right: 0;
      margin-left: auto;
    }
  }
}

.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dash-line {
  width: 100%;
  height: 2px;
  background: #e0e0e0;
  opacity: 0.5;
}

.opacity-gray {
  opacity: 0.45;
  color: #000 !important;
}

.btn-show-ship {
  width: 168px;
  height: 52px;
  background: #fff;
  border-radius: 28px;
  border: 2px solid #e0e0e0;
  font-size: 24px;
  font-family: $font-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 52px;
  margin-right: 0;
  margin-left: auto;
  margin-top: 20px;
}

.shipping-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-radius: 24px 24px 0 0;

  .shipping-title {
    position: relative;
    height: 112px;
    text-align: start;
    padding-left: 30px;
    padding-right: 110px;
    display: flex;
    align-items: center;

    .shipping-title-name {
      font-weight: 500;
      font-size: 30px;
      color: #333333;
      word-break: break-all;
    }
  }

  .shipping-close {
    position: absolute;
    width: 92px;
    height: 100%;
    top: 0;
    right: 0;
  }

  .shipping-info {
    text-align: start;
    padding: 30px 40px;

    .sub-title {
      font-weight: 400;
      font-size: 26px;
      color: #666666;
      flex: none;
      margin-right: 30px;
    }

    .shipping-address {
      font-weight: 400;
      font-size: 26px;
      color: rgba(0,0,0,0.45);
      padding: 20px;
      background: #F8F8F8;
      border-radius: 12px 12px 12px 12px;
      word-break: break-all;
      margin-top: 16px;

      div+div {
        margin-top: 8px;
      }
    }

    .shipping-item {
      font-weight: 400;
      font-size: 26px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 34px;
    }

    .ship-no-text {
      display: flex;
      align-items: center;
    }

    .copy-btn {
      margin-left: 12px;
      font-weight: 400;
      font-size: 24px;
      height: 40px;
      flex: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderItem.vue